import jsonp from 'jsonp';
import axios from 'axios';
import * as utils from '@utils';

const objToAjaxParams = (data) => {
  let txtArr = [];
  for (let key in data) {
    txtArr.push(`${key}=${data[key]}`);
  }
  txtArr.push('callback');
  return txtArr.join('&');
};

export const getJSON = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    jsonp(
      url,
      {
        param: objToAjaxParams({
          ...data,
          cid: utils.getUrlParams('cid'),
          scid: utils.getUrlParams('scid')
        }),
        prefix: 'jsonpCallback'
      },
      (err, response) => {
        if (err) {
          console.error('JSONP 请求失败:', err);
          reject(err);
        } else {
          resolve(response);
        }
      }
    );
  });
};

export const get = (url, data) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: data || {}
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error('GET 请求失败:', err);
        reject(err);
      });
  });
};

export const post = (url, data, responseType = 'json') => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data: data,
      responseType
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error('POST 请求失败:', err);
        reject(err);
      });
  });
};
